var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFehlermeldung(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "externe_Vorgangsnummer._warning",
    "data-name": "externe Vorgangsnummer. warning",
    transform: "translate(-6281 1407)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_120",
    "data-name": "Ellipse 120",
    cx: 50,
    cy: 50,
    r: 50,
    transform: "translate(6281 -1407)",
    fill: "#e8fcff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "warning",
    d: "M239.409,241.509l-22.716-41.59a3.68,3.68,0,0,0-1.391-1.457,3.746,3.746,0,0,0-3.841,0,3.68,3.68,0,0,0-1.391,1.457l-22.714,41.59a3.557,3.557,0,0,0,.066,3.709,4.669,4.669,0,0,0,1.391,1.788c.6.331,1.192.927,1.855.927H236.1c.662,0,1.325-.6,1.855-.927a4.048,4.048,0,0,0,1.391-1.59,3.919,3.919,0,0,0,.066-3.907Zm-30.067-24.768a3.643,3.643,0,1,1,7.285,0v11.126a3.643,3.643,0,1,1-7.285,0Zm4.106,24.238a3.709,3.709,0,1,1,3.709-3.709A3.7,3.7,0,0,1,213.448,240.979Z",
    transform: "translate(6117.617 -1579.933)",
    fill: "#00c3de"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFehlermeldung);
export default __webpack_public_path__ + "static/media/Fehlermeldung.92506c8bd8f4026f908ab62ed2cbeeb9.svg";
export { ForwardRef as ReactComponent };